export const USER_ACTIONS = {
  SET_SEARCH: 'USER_ACTIONS/SET_SEARCH',
  CHANGE_ONLINE_STATUS: 'USER_ACTIONS/CHANGE_ONLINE_STATUS',
  LOAD_USERS_START: 'USER_ACTIONS/LOAD_START',
  LOAD_USERS_SUCCESS: 'USER_ACTIONS/LOAD_SUCCESS',
  LOAD_USERS_FAILURE: 'USER_ACTIONS/LOAD_FAILURE',
  UPDATE_CURRENT_USER: 'USER_ACTIONS/UPDATE_CURRENT_USER',
}
